export default "__VITE_ASSET__4a902328__"